import {
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AdminRole, AuthorizationService } from '@tnq/shared/core';

/**
 * Structural directive that only renders its template when the logged-in
 * admin has one of the given role(s).
 *
 * Usage:
 *   <button *tnqHasRole="AdminRole.SuperAdmin">Delete</button>
 *   <button *tnqHasRole="[AdminRole.SuperAdmin, AdminRole.Admin]">Edit</button>
 */
@Directive({
  selector: '[tnqHasRole]',
})
export class HasRoleDirective {
  readonly templateRef = inject(TemplateRef<unknown>);
  readonly viewContainer = inject(ViewContainerRef);
  readonly authorization = inject(AuthorizationService);

  tnqHasRole = input.required<AdminRole | AdminRole[]>();

  constructor() {
    effect(() => {
      const required = this.tnqHasRole();
      const roles = Array.isArray(required) ? required : [required];
      const allowed = this.authorization.hasAnyRole(roles)();

      this.viewContainer.clear();
      if (allowed) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }
}
